import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./index.scss";
import { HeaderConfig } from "./config";
import { getOfflineData } from "../../../utils/offline-services";
import { invokeApi, HTTP_METHODS, plainApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import AppContext from "../../../utils/context";
import { DATE_FORMATS, USER_ROLES } from "../../../utils/constants";
import TicketFilters from "../../../core/ticket-filters";
import CustomTable from "../../../core/custom-table";
import { formatDate, PAGE_LIMIT } from "../../../utils";
import { Box } from "@mui/material";
import CustomButtonComponent from "../../../core/custom-button";

const FloatEngineMovements = () => {
  const { userDetails = {} } = useContext(AppContext);
  const navigate = useNavigate();
  const [viewTicket, setViewTicket] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [mainFilters, setMainFilters] = useState({});
  const [pastTickets, setPastTickets] = useState({
    results: [],
  });
  const storedFilters = JSON.parse(
    sessionStorage.getItem("floatEngineFilters")
  );
  const [filters, setFilters] = useState(
    storedFilters || {
      page: 1,
      limit: PAGE_LIMIT,
      sortBy: "-createdAt",
    }
  );

  useEffect(() => {
    if (!getOfflineData("user")) {
      navigate("/");
    } else if (userDetails && userDetails.id) {
      loadData(filters);
    }
  }, [userDetails]);
  useEffect(() => {
    if (filters) {
      sessionStorage.setItem("floatEngineFilters", JSON.stringify(filters));
    }
    if (mainFilters) {
      sessionStorage.setItem(
        "floatEngineMainFilters",
        JSON.stringify(mainFilters)
      );
    }
  }, [filters, mainFilters]);
  const loadData = (filters) => {
    setIsLoading(true);
    let url = REST_URLS.TICKETS;
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${url}`, null, {
      ...filters,
      engineReplacementStatus: "APPROVED,YET_TO_DISPATCH,ENGINE_DISPATCHED",
    })
      .then((response) => {
        if (response.results) {
          const result = response.results.map((ele) => ({
            ...ele,
            engineReplacementApprovedDate: formatDate(
              ele?.engineReplacementApprovedDate,
              DATE_FORMATS["DD-MM-YYYY"]
            ),
            approvedBy: ele?.assignedApprover?.name,
          }));
          setPastTickets({
            ...response,
            results: result,
          });
        }
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  };

  const getComplaintDetails = (data) => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.COMPLAINT}/${data.id}`,
      null
    )
      .then((response) => {
        if (response) {
          setViewTicket({
            ticketId: data.id,
            ...response,
          });
        }
      })
      .catch((err) => console.error(err));
  };

  const onRowClick = (data) => {
    if (userDetails.role === USER_ROLES.ADMIN) {
      navigate(`/admin/float-engine/${data.id}`);
    } else {
      getComplaintDetails(data);
    }
  };
  const downloadReport = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.TICKETS}`,
      null,
      {
        ...filters,
        ...mainFilters,
        engineReplacementStatus: "APPROVED,YET_TO_DISPATCH,ENGINE_DISPATCHED",
        download: true,
      },
      "blob"
    )
      .then((res) => {
        if (!res.message) {
          const url = window.URL.createObjectURL(res);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Float Engine Movements.xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      })
      .catch((err) => console.error(err));
  };

  const applyFilters = (newFilter) => {
    let updatedFilters = { ...filters };
    if (newFilter.ticketId) {
      updatedFilters._id = newFilter.ticketId;
    } else {
      delete updatedFilters._id;
    }

    if (newFilter.serviceEngineer) {
      updatedFilters.serviceEngineer = newFilter.serviceEngineer;
    } else {
      delete updatedFilters.serviceEngineer;
    }

    loadData(updatedFilters);
    setFilters(updatedFilters);
  };
  return (
    <>
      <div className="page-body page-load">
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
          <div>
            <p className="tab-name">Float Engine Movements</p>
            <p className="section-name">Approved engine replacement</p>
          </div>
          <CustomButtonComponent
            variant="contained"
            color="success"
            onClick={downloadReport}
            sx={{ mr: 6 }}
          >
            Download
          </CustomButtonComponent>
        </Box>

        <CustomTable
          header={HeaderConfig}
          data={pastTickets.results || []}
          pageCount={pastTickets.totalPages}
          onClick={onRowClick}
          filters={filters}
          onChange={(page) => {
            const updatedFilters = { ...filters, page };

            setFilters(updatedFilters);
            sessionStorage.setItem(
              "floatEngineFilters",
              JSON.stringify(updatedFilters)
            );

            loadData({
              ...updatedFilters,
              ...mainFilters,
            });
          }}
          filterCom={
            <TicketFilters
              loadData={loadData}
              setMainFilters={setMainFilters}
              filter={filters}
            />
          }
          isLoading={isLoading}
        />
      </div>
    </>
  );
};

export default FloatEngineMovements;
